export default __webpack_public_path__ + "static/media/landing-blockimg3.4a8c47c2.jpg";